import Vue from 'vue'; //  VueJS
import VueI18n from 'vue-i18n';
import Vuetify from 'vuetify';
import lineClamp from 'vue-line-clamp'

import 'vuetify/dist/vuetify.min.css';
import 'babel-polyfill';

import App from './App';
import store from './store';
import TranslateService from '@/services/TranslateService';
const translateService = new TranslateService();

Vue.use(VueI18n);
Vue.use(Vuetify);
Vue.use(lineClamp);

Vue.config.productionTip = false;

//retrieve language from parameters
const appUrl = new URL(window.location.href);
const definedLang = appUrl.searchParams.get('lang');

translateService.getTranslationData(definedLang).then(i18n => {
  new Vue({
    i18n,
    store,
    render: h => h(App)
  }).$mount('#app');
});
